import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Text, Stack } from '@guestyci/arc';
import { GUESTY_REQUEST_A_DEMO_URL } from 'utils/consts';

const RegistrationLink = ({
  registrationUrl = GUESTY_REQUEST_A_DEMO_URL,
}) => {
  return (
    <Stack direction="row" spacing={1} align="center">
      <Text size="sm" className="gst-text-muted-foreground">
        {t('New to Guesty?')}
      </Text>
      <Text size="sm" className="gst-text-primary gst-font-medium">
        <a href={registrationUrl} className="gst-text-inherit">
          {t('Register a new account')}
        </a>
      </Text>
    </Stack>
  );
};

export default RegistrationLink;
